const TinyChevronLeft = () => (
  <>
    <path
      fill="currentColor"
      d="M13.373 8.755q.168 0 .289.111t.12.293v5.677a.37.37 0 0 1-.123.293.42.42 0 0 1-.289.111q-.04 0-.284-.13l-2.676-2.678a.7.7 0 0 1-.143-.199.55.55 0 0 1-.05-.235q0-.128.05-.236a.7.7 0 0 1 .143-.199l2.677-2.677a.5.5 0 0 1 .129-.093.34.34 0 0 1 .157-.038"
    />
  </>
)
export default TinyChevronLeft
